import { useEffect, useState } from "react";
import socketIOClient from "socket.io-client";
import { useSelector } from "react-redux";
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import ChatSharpIcon from '@mui/icons-material/ChatSharp';

import "../../chats.css";

const UserChatComponent = () => {
  
  const [socket, setSocket] = useState(false);

  //   let chat = [
  //       {"client": "msg"},
  //       {"client": "msg"},
  //       {"admin": "msg"},
  //   ]
  
  const [chat, setChat] = useState([]);
  const [messageReceived, setMessageReceived] = useState(false);
  const [chatConnectionInfo, setChatConnectionInfo] = useState(false);
  const [reconnect, setReconnect] = useState(false);

  const userInfo = useSelector((state) => state.userRegisterLogin.userInfo);

  useEffect(() => {
    if (!userInfo.isAdmin) {
      setReconnect(false);
      var audio = new Audio("/audio/chat-msg.mp3");
      const socket = socketIOClient();
      socket.on("no admin", (msg) => {
        setChat((chat) => {
          return [...chat, { admin: "no admin here now" }];
        })
      })
      socket.on("server sends message from admin to client", (msg) => {
        setChat((chat) => {
          return [...chat, { admin: msg }];
        })
        setMessageReceived(true);
        audio.play();
        const chatMessages = document.querySelector(".cht-msg");
        chatMessages.scrollTop = chatMessages.scrollHeight;
      })
      setSocket(socket);
      socket.on("admin closed chat", () => {
        setChat([]);
        setChatConnectionInfo("Admin closed chat. Type something and submit to reconnect");
        setReconnect(true);
      })
      return () => socket.disconnect();
    }
  }, [userInfo.isAdmin, reconnect]);

  const clientSubmitChatMsg = (e) => {
    if (e.keyCode && e.keyCode !== 13) {
      return;
    }
    setChatConnectionInfo("");
    setMessageReceived(false);
    const msg = document.getElementById("clientChatMsg");
    let v = msg.value.trim();
    if (v === "" || v === null || v === false || !v) {
      return;
    }
    socket.emit("client sends message", v);
    setChat((chat) => {
      return [...chat, { client: v }];
    });
    msg.focus();
    setTimeout(() => {
      msg.value = "";
      const chatMessages = document.querySelector(".cht-msg");
      chatMessages.scrollTop = chatMessages.scrollHeight;
    }, 200)
  };

  return !userInfo.isAdmin ? (
    <>
      <input type="checkbox" id="check" />

      <label className="chat-btn" htmlFor="check">
        
        <i className="bi bi-chat-dots comment"></i>

        <Tooltip title="parla con noi">
          <ChatSharpIcon />
        </Tooltip>

        { messageReceived && 
          <span className="position-absolute top-0 start-10 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
        }

        <i className="bi bi-x-circle close"></i>
      </label>

      <div className="chat-wrapper">
        <div className="chat-header">

           {/* 
              <h6>Help Desk - Online</h6>
            */}

          <Typography variant="h7" color='#dfdfde'
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 3, paddingRight: 1,
              p: 0, m: 0,
            }}
          >
            Help Desk - online
          </Typography>

        </div>

        <div className="chat-form">
        
          <div className="cht-msg">
            <p>{chatConnectionInfo}</p>

            {chat.map((item, id) => (
              <div key={id}>
                {item.client && (
                  <p>
                    <b>Tu hai scritto:</b> {item.client}
                  </p>
                )}
                {item.admin && (
                  <p className="bg-primary p-3 ms-4 text-light rounded-pill">
                    <b>HelpDesk ha scritto:</b> {item.admin}
                  </p>
                )}
              </div>
            ))}

          </div>

          <Stack
            spacing={2}
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
          >

            <textarea
              onKeyUp={(e) => clientSubmitChatMsg(e)}
              id="clientChatMsg"
              className="form-control"
              placeholder="Il tuo messaggio"
            >             
            </textarea>

            &nbsp;&nbsp;

            {/* 
            <button
              onClick={(e) => clientSubmitChatMsg(e)}
              className="btn btn-success btn-block"
            >
              Invia
            </button>
            */}

            <Button
              variant="contained"
              size="small"
              color="warning"
              onClick={(e) => clientSubmitChatMsg(e)}
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              }}
            >
              Invia
            </Button>
          </Stack>

        </div>
      </div>
    </>
  ) : null;
};

export default UserChatComponent;
